import { Box, CircularProgress } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Route } from 'react-router-dom';
import UnauthorizedScreen from 'screens/Unauthorized';
import { compose } from 'recompose';
import { getPermissionConfig, hasScopeAndActionPermission } from 'Utils/scopeAndPermission';

function ProtectedRoute(props) {
  const { component: Component, children, userStore, path, permissionStore, ...rest } = props;
  const { user } = userStore;
  const userScopes = user?.scopes || [];

  const rawPath = Array.isArray(path) ? path[0] : path;

  const { scopes, actionPermission } = getPermissionConfig(rawPath);

  const canAccess = hasScopeAndActionPermission({ scopes, actionPermission, userScopes, permissionStore });

  if (!userStore.isFetchedUser) {
    return (
      <Box display="flex" alignItems={'center'} justifyContent={'center'} style={{ height: '100vh', width: '100%' }}>
        <CircularProgress size={75} thickness={2} />
      </Box>
    );
  }

  return (
    <Route
      path={path}
      {...rest}
      render={(routeProps) => {
        if (canAccess) {
          return Component ? <Component {...routeProps} /> : children;
        } else {
          return <UnauthorizedScreen />;
        }
      }}
    />
  );
}

export default compose(inject('userStore', 'permissionStore'), observer)(ProtectedRoute);
